import { Component, OnInit } from '@angular/core';

@Component({ templateUrl: 'messageQueue.component.html' })
export class MessageQueueComponent implements OnInit {
  constructor() { }
 
  ngOnInit(): void {
  }
}